import { put, select, takeLatest } from 'redux-saga/effects'
import { getAddMedicationAdministeredSelector } from '../selectors'
import { setAddMedicationAdministeredData } from '../store/addMedicationAdministered.actions'
import { AddMedicationAdministeredConstants } from '../store/addMedicationAdministered.constants'
import { IAddMedicationAdministeredState } from '../store/addMedicationAdministered.types'

export function* setRate() {
  const addMedicationAdministeredState: IAddMedicationAdministeredState = yield select(
    getAddMedicationAdministeredSelector
  )
  const { rate, medicationAdministered, addMedicationAdministeredData } = addMedicationAdministeredState
  const selectedMedication = addMedicationAdministeredData.filter(
    (medication) => medication.key === medicationAdministered?.key
  )
  if (selectedMedication && selectedMedication.length) {
    selectedMedication[0].rate = rate
    yield put(setAddMedicationAdministeredData(addMedicationAdministeredData))
  }
}
export function* setRateSaga() {
  yield takeLatest([AddMedicationAdministeredConstants.SET_RATE], setRate)
}
